var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Dialog from '../../../components/atoms/Dialog';
import ProducerBankAccountForm from '../../../components/pages/ProducerBankAccountForm';
var ProducerBankAccountFormWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: -30px;\n"], ["\n  margin-top: -30px;\n"])));
var ProducerBankAccountFormDialog = function (_a) {
    var loading = _a.loading, open = _a.open, onSubmit = _a.onSubmit, onClose = _a.onClose;
    var t = useTranslation().t;
    return (React.createElement(Dialog, { title: React.createElement(React.Fragment, null,
            t('pages.producerBankAccounts.new'),
            React.createElement(IconButton, { "aria-label": "close", onClick: onClose, sx: { position: 'absolute', right: 8, top: 8 } },
                React.createElement(CloseIcon, null))), open: open, onClose: onClose },
        React.createElement(Typography, null, t('pages.offerUpload.suggestToCreateBankAccountText')),
        React.createElement(ProducerBankAccountFormWrapper, null,
            React.createElement(ProducerBankAccountForm, { loading: loading, onSubmit: onSubmit }))));
};
export default ProducerBankAccountFormDialog;
var templateObject_1;
